/** The localStorage auth data key. */
export const localStorageAuthDataKey = 'authData';
